import React from 'react';
import PropTypes from 'prop-types';
import { Upload } from 'antd';

const { Dragger } = Upload;

export default function upload(props) {
  return (
    <>
      {!props.dragger && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Upload {...props}>
          {props.children}
        </Upload>
      )}

      {props.dragger && (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Dragger {...props}>
          {props.children}
        </Dragger>
      )}
    </>
  );
}

upload.propTypes = {
  dragger: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.element
  ]).isRequired
};

upload.defaultProps = {
  dragger: false
};

upload.displayName = 'Upload';
